import { request } from './request'
import Cookies from 'js-cookie'
import md5 from 'js-md5'
import moment from 'moment'
/**
 * etl通用查询接口
 * @param {*} pathQuer 自定义路径和方法 必传
 * @param {*} data 请求参数 base 属性为必传
 */
export const generalQuery = (pathQuer, data, urlPrefix = '/querys/query') => {
  const queryPath = pathQuer.split('/')
  const sign = md5For32(queryPath)
  Object.assign(data.base, { sign })
  return {
    url: `/ocean/api/v1/shop/etl${urlPrefix}/${queryPath[0]}/${queryPath[1]}`,
    data
  }
}
function md5For32(queryPath) {
  const na = md5(window.navigator.userAgent)
  return md5(queryPath[1] + '#' + na + '#' + queryPath[0])
}
const shopId = Cookies.get('shopId')
const shopName = Cookies.get('shopName')
const setQuery = (url, template, data, urlPrefix = '/querys/query') => {
  // 对请求（今日/昨日）/非今昨添加区分类型dateType
  let iscludes = [
    'load.shoplus.turnover',
    'load.shoplus.discount',
    'load.shoplus.customer.price',
    'load.shoplus.associate.rate',
    'load.shoplus.order.wait.fail',
    'load.shoplus.repurchaser'
  ]
  // if (data && data.startDate) {
  //   if (iscludes.includes(template)) {
  //     if (
  //       data.startDate === data.endDate &&
  //       (moment().format('YYYY-MM-DD') === data.startDate ||
  //         moment()
  //           .subtract(1, 'days')
  //           .format('YYYY-MM-DD') === data.startDate)
  //     ) {
  //       data.dateType = 1
  //     } else {
  //       data.dateType = 2
  //     }
  //   }
  // }
  // delete data.templateId
  let param = {
    base: {
      template_id: template
    },
    params: {
      ...data
    }
  }
  return generalQuery(url, param, urlPrefix)
}
// 数据概览
export const postDataOverview = data => {
  const url = 'template/queryByTemplate_1614581638666_1614752540448_1614755307582'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.site.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 销额-总销额环比图
export const postSaleRing = data => {
  const url = 'template/queryByTemplate_1614587982842_1614751945732'
  data.templateId = 'load.shoplus.turnover'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.turnover', data)
  if (query.data.params && query.data.params.startDate) {
    if (
      query.data.params.startDate === query.data.params.endDate &&
      (moment().format('YYYY-MM-DD') === query.data.params.startDate ||
        moment()
          .subtract(1, 'days')
          .format('YYYY-MM-DD') === query.data.params.startDate)
    ) {
      query.data.params.dateType = 1
    }
  }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 销额-折扣金额图
export const postSaleDiscount = data => {
  const url = 'template/queryByTemplate_1614588266890_1614753066902'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.discount', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 销额-热销商品表
export const postSaleShop = data => {
  const url = 'template/queryByTemplate_1614588507281_1614757092451'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.product.top', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 销额-国家/区域总销售额占比图
export const postSaleCountry = data => {
  const url = 'template/queryByTemplate_1614589884979_1614753266273'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.sale.country', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 订单-客单价连带率概览
export const postOrderCustomerOverview = data => {
  const url = 'template/queryByTemplate_1614590949813_1614666770183'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.customer.price.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 订单-客单价图
export const postOrderCustomer = data => {
  const url = 'template/queryByTemplate_1614590949813_1614824748427'
  data.templateId = 'load.shoplus.customer.price'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.customer.price', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 订单-连带率图
export const postOrderRate = data => {
  const url = 'template/queryByTemplate_1614590949813'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.associate.rate', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 订单-待支付和支付失败订单
export const postOrderInfo = data => {
  const url = 'template/queryByTemplate_1614591258802'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.order.wait.fail', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 订单-支付成功订单UTM来源
export const postOrderUTM = data => {
  const url = 'template/queryByTemplate_1614591364892_1614825614563'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.utm', data)
  if (query.data && query.data.params && !query.data.params.utm_type) {
    query.data.params.utm_type = 'utm_source'
  }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 订单-复购客图
export const postOrderRepurchase = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614825732126'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.repurchaser', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 订单-复购客概览
export const postOrderRepurchaseOverview = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614597309308'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.repurchaser.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 独立访客-跳出率
export const postClientRateOverview = data => {
  const url =
    'template/queryByTemplate_1614591364892_1614591697462_1614595436010_1614598024142_1614821445851_1614843604323'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.out.rate.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 独立访客-人均浏览时长概览
export const postClientRateTimeOverview = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614595436010_1614598024142_1614821445851'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.view.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 独立访客-访问国家/地区分布图
export const postClientCountry = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614595436010_1614596341046_1614832289425'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.client.country', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 独立访客-访客UTM来源
export const postClientUTM = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614595436010_1614596341046_1614596658108'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.client.utm', data)
  if (query.data && query.data.params && !query.data.params.utm_type) {
    query.data.params.utm_type = 'utm_source'
  }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 独立访客-跳出率
export const postClientOut = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614595436010_1614598024142'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.out.rate', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 独立访客-人均浏览时长
export const postClientTime = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614595436010_1614832356732'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.view.per', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 顾客行为-转化漏斗
export const postTransFunnel = data => {
  const url = 'template/queryByTemplate_1614595889769'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.trans.funnel.v2', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 每日概况
export const dayDashboard = data => {
  const url = 'template/queryByTemplate_1614581638666_1614752540448_1614755307582_1615964990251'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.site.overview.today', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 顾客行为-活动转化率图
export const postTransRate = data => {
  const url = 'template/queryByTemplate_1614596797016'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.active.rate.chart.v2', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 顾客行为-活动转化率概览
export const postTransRateOverview = data => {
  const url = 'template/queryByTemplate_1614596797016_1614597410743'
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, 'load.shoplus.active.rate.overview.v2', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 报表明细-自选时间模板
export const postReportItemTpl = data => {
  const map = {
    'load.shoplus.sale.report.v2': 'template/queryByTemplate_1614596797016_1614597091563',
    'load.shoplus.product.sale.report.v2': 'template/queryByTemplate_1614596797016_1614597091563_1614912421751',
    'load.shoplus.order.report.v2': 'template/queryByTemplate_1614596797016_1614597091563_1614912421751_1614913393166',
    'load.shoplus.flow.report.v2':
      'template/queryByTemplate_1614596797016_1614597091563_1614912421751_1614913393166_1614914008062',
    'load.shoplus.country.flow.report.v2':
      'template/queryByTemplate_1614596797016_1614597091563_1614912421751_1614913393166_1614914008062_1614914398202',
    'load.shoplus.trans.report.v2': 'template/queryByTemplate_1614596797016_1614597091563_1614915041036',
    'load.shoplus.repurchaser.report.v2': 'template/queryByTemplate_1614915376349',
    'load.shoplus.discount.report.v2': 'template/queryByTemplate_1614596797016_1614915595941',
    'load.shoplus.order.recall.report.v2':
      'template/queryByTemplate_1614596797016_1614597091563_1614912421751_1614913393166_1614915930077'
  }
  const url = map[data.template_id]
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, data.template_id, data)

  if (query.data && query.data.params.pageInfo) {
    query.data.pageInfo = query.data.params.pageInfo
    delete query.data.params.pageInfo
  }
  console.log(query, 'query')
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 导出报表明细-自选时间模板
export const exportReportItemTpl = data => {
  const map = {
    'load.shoplus.sale.report.v2': 'template/queryByTemplate_1614596797016_1614597091563',
    'load.shoplus.product.sale.report.v2': 'template/queryByTemplate_1614596797016_1614597091563_1614912421751',
    'load.shoplus.order.report.v2': 'template/queryByTemplate_1614596797016_1614597091563_1614912421751_1614913393166',
    'load.shoplus.flow.report.v2':
      'template/queryByTemplate_1614596797016_1614597091563_1614912421751_1614913393166_1614914008062',
    'load.shoplus.country.flow.report.v2':
      'template/queryByTemplate_1614596797016_1614597091563_1614912421751_1614913393166_1614914008062_1614914398202',
    'load.shoplus.trans.report.v2': 'template/queryByTemplate_1614596797016_1614597091563_1614915041036',
    'load.shoplus.repurchaser.report.v2': 'template/queryByTemplate_1614915376349',
    'load.shoplus.discount.report.v2': 'template/queryByTemplate_1614596797016_1614915595941',
    'load.shoplus.order.recall.report.v2':
      'template/queryByTemplate_1614596797016_1614597091563_1614912421751_1614913393166_1614915930077'
  }
  const url = map[data.template_id]
  data.shopId = shopId
  data.shopName = shopName
  let query = setQuery(url, data.template_id, data, '/export')

  if (query.data && query.data.params.pageInfo) {
    query.data.pageInfo = query.data.params.pageInfo
    delete query.data.params.pageInfo
  }
  return request({
    method: 'post',
    url: query.url,
    data: query.data,
    responseType: 'blob'
  })
}

// 营销分析 数据概览
export const postTopDataCount = data => {
  const url = 'template/queryByTemplate_66666'
  let query = setQuery(url, 'load.Integration.data.overview', data)
  // let query = {
  //   url,
  //   data: {
  //     template_id: 'load.Integration.data.overview',
  //     ...data
  //   }
  // }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 营销分析-数据概览-广告销额
export const postAdTopSaleData = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338_1620359863164'
  let query = setQuery(url, 'load.Integration.ad.saleamount.top5', data)
  // let query = {
  //   url,
  //   data: {
  //     template_id: 'load.Integration.ad.saleamount.top5',
  //     ...data
  //   }
  // }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 营销分析-数据概览-费用Top5
export const postAdTopFeeData = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338'
  let query = setQuery(url, 'load.Integration.ad.fee.top5', data)
  // let query = {
  //   url,
  //   data: {
  //     template_id: 'load.Integration.ad.fee.top5',
  //     ...data
  //   }
  // }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-数据概览-渠道分解
export const postChannelData = data => {
  const url = 'template/queryByTemplate_66666_1619663692184'
  let query = setQuery(url, 'load.Integration.channel.analyse', data)
  // let query = {
  //   url,
  //   data: {
  //     template_id: 'load.Integration.channel.analyse',
  //     ...data
  //   }
  // }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-数据概览-广告转化漏斗
export const postAdTransData = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617'
  let query = setQuery(url, 'load.Integration.ad.trans', data)
  // let query = {
  //   url,
  //   data: {
  //     template_id: 'load.Integration.ad.trans',
  //     ...data
  //   }
  // }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-数据概览-趋势分析
export const posttrendData = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1620283245214'
  let query = setQuery(url, 'load.Integration.trend.analyse', data)
  // let query = {
  //   url,
  //   data: {
  //     template_id: 'load.Integration.trend.analyse',
  //     ...data
  //   }
  // }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-广告分析-概览
export const postAdData = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353'
  let query = setQuery(url, 'load.Integration.ad.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-广告分析-广告营销趋势
export const getAdsSalesEcharts = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1625220272055'
  let query = setQuery(url, 'load.Integration.ad.market.trend', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-广告分析-店铺下拉框
export const getShopList = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664'
  let query = setQuery(url, 'load.Integration.merchant.shop', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

export const getShopIdList = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664'
  let query = setQuery(url, 'load.Integration.merchant.shop', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-广告分析-广告账户下拉框
export const getAdAccountList = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1620356136626'
  // let query = {
  //   url,
  //   data: {
  //     template_id: 'load.Integration.ad.account.search',
  //     ...data
  //   }
  // }
  let query = setQuery(url, 'load.Integration.ad.account.search', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-广告分析-广告系列下拉框
export const getAdCampaignList = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1620356136626_1620356232039'
  let query = setQuery(url, 'load.Integration.ad.campaign.search', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-广告分析-列表详情
export const getDetailList = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474'
  let query = setQuery(url, 'load.Integration.ad.detail', data)
  if (query.data && query.data.params && query.data.params.pageInfo) {
    query.data.pageInfo = query.data.params.pageInfo
    delete query.data.params.pageInfo
  }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析 工单概览 概览
export const getWorkOrderCount = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084_1619681190037_1619681366336_1619681562332'
  let query = setQuery(url, 'load.Integration.workorder.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析-退货概览-退款概览
export const getRefundCount = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167'
  let query = setQuery(url, 'load.Integration.refund.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析-退货概览-退款概览
export const getSaleCount = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681'
  let query = setQuery(url, 'load.Integration.sale.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析 工单概览 收到邮件趋势图
export const getEmailLineCharts = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084_1619681190037_1619681366336_1619681562332_1619682003208'
  let query = setQuery(url, 'load.Integration.workorder.trend', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析 工单概览 收到邮件类型占比
export const getEmailTypePieCharts = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084_1619681190037_1619681366336_1619681562332_1619682003208_1619682111637'
  let query = setQuery(url, 'load.Integration.workorder.emailtype.percentage', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析 工单概览 回复数分析
export const getEmailReplyTable = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084_1619681190037_1619681366336_1619681562332_1619682003208_1619682111637_1619682535082'
  let query = setQuery(url, 'load.Integration.workorder.handle', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 供应链分析 履约分析 概览
export const getPerformanceCount = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939'
  let query = setQuery(url, 'load.Integration.promise.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 供应链分析 履约分析 发货妥投率趋势图
export const getDelieveredLineCharts = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618'
  let query = setQuery(url, 'load.Integration.promise.trend', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 供应链分析 履约分析 各店铺发货情况
export const getShippingTable = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628'
  let query = setQuery(url, 'load.Integration.promise.shipping', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 供应链分析 履约分析 各店铺妥投情况
export const getDelieveredTable = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438'
  let query = setQuery(url, 'load.Integration.promise.receive', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-销售分析-总体成交趋势
export const getTransactionData = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990'
  let query = setQuery(url, 'load.Integration.sale.trend', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-销售分析-各站点经营概况
export const getTableConfigData = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899'
  let query = setQuery(url, 'load.Integration.sale.detail', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-销售分析-商品销售概况
export const getProductsTableConfigData = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084_1619681190037_1619681366336_1619681562332_1619682003208_1619682111637_1619682535082_1620893575377'
  let query = setQuery(url, 'load.Integration.sale.analyse', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 运营分析-销售分析-商品销售概况
export const getMonthlyProfitCount = data => {
  const url = 'template/queryByTemplate_1622166795095'
  let query = setQuery(url, 'load.Integration.profit.monthly.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-利润月报-明细
export const getMonthlyProfitTable = data => {
  const url = 'template/queryByTemplate_1622170350302'
  let query = setQuery(url, 'load.Integration.profit.monthly.detail', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-行为概览-站点选择
export const getShoplusList = data => {
  const url = 'template/queryByTemplate_66666_1622188559030_1622528534134'
  let query = setQuery(url, 'load.Integration.op.shop.chose', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-行为概览-概览
export const getPerformanceBoardCount = data => {
  const url = 'template/queryByTemplate_66666_1622188559030'
  let query = setQuery(url, 'load.Integration.op.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-行为概览-访客地区来源
export const getVisitorAreaSoure = data => {
  const url = 'template/queryByTemplate_66666_1622188559030_1622190047606'
  let query = setQuery(url, 'load.Integration.op.area.source', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-行为概览-页面访问概况
export const getVisitorPageCount = data => {
  const url = 'template/queryByTemplate_66666_1622188559030_1622190047606_1622193123269'
  let query = setQuery(url, 'load.Integration.op.page.view', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-行为概览-转化漏斗
export const getChangeFunnel = data => {
  const url = 'template/queryByTemplate_66666_1622188559030_1622441965690'
  let query = setQuery(url, 'load.Integration.op.trans.funnel', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-行为概览-访客utm来源
export const getUtmSourceCharts = data => {
  const url = 'template/queryByTemplate_66666_1622188559030_1622441965690_1622442303773'
  let query = setQuery(url, 'load.Integration.op.visitor.utmsource', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-行为概览-搜索行为分析
export const getSearchTable = data => {
  const url = 'template/queryByTemplate_1622166795095_1622799887067'
  let query = setQuery(url, 'load.Integration.op.analyse.search', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 运营分析-行为概览-加购行为分析
export const getAddBuyTable = data => {
  const url = 'template/queryByTemplate_1622166795095_1622799887067_1622800417192'
  let query = setQuery(url, 'load.Integration.op.analyse.addcart', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析-退货概览-退款原因占比
export const getRefundReasonData = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854'
  let query = setQuery(url, 'load.Integration.refund.reason', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析-退货概览-支付订单到退款间隔时间统计
export const getRefundTimeData = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267'
  let query = setQuery(url, 'load.Integration.refund.time', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析-退货概览-退款商品统计
export const getRefundProductData = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084'
  let query = setQuery(url, 'load.Integration.refund.product', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析-退货概览-退款国家统计
export const getRefundCountryData = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084_1619681190037'
  let query = setQuery(url, 'load.Integration.refund.country', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 售后分析-退货概览-退款金额趋势图
export const getRefundMoneyData = data => {
  const url =
    'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084_1619681190037_1619681366336'
  let query = setQuery(url, 'load.Integration.refund.trend', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 首页-今日经营日报
export const getTodayAnalysis = data => {
  const url = 'template/queryByTemplate__1621391275675'
  let query = setQuery(url, 'load.Integration.sale.daily', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

let mock = 'http://yapi.batmobi.cn/mock/337/'
// 仓库管理-商品库存-库存明细表
export const getStockTable = data => {
  const url = 'template/queryByTemplate__1621391275675_1621561635793'
  let query = setQuery(url, 'load.Integration.stock.detail.search', data)
  if (query.data && query.data.params && query.data.params.pageInfo) {
    query.data.pageInfo = query.data.params.pageInfo
    delete query.data.params.pageInfo
  }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 仓库管理-商品库存-供应商列表
export const getSupplierList = data => {
  const url = 'template/queryByTemplate__1621391275675_1621561635793_1621562680984_1621562981288_1621563206034'
  let query = setQuery(url, 'load.Integration.stock.supplier.search', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 仓库管理-商品库存-库存汇总
export const getStockCount = data => {
  const url = 'template/queryByTemplate__1621391275675_1621561635793_1621562680984_1621562981288'
  let query = setQuery(url, 'load.Integration.stock.merge', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 仓库管理-商品库存-库存流水
export const getStockFlow = data => {
  const url = 'template/queryByTemplate__1621391275675_1621561635793_1621562680984'
  let query = setQuery(url, 'load.Integration.stock.flow', data)
  if (query.data && query.data.params && query.data.params.pageInfo) {
    query.data.pageInfo = query.data.params.pageInfo
    delete query.data.params.pageInfo
  }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-销售概览-商品销售概况
export const getSalesTable = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1619666490474_1619668052664_1619668271939_1619675342618_1619675567628_1619676130438_1619677809681_1619679173990_1619679339899_1619679684167_1619680231854_1619680435267_1619680715084_1619681190037_1619681366336_1619681562332_1619682003208_1619682111637_1619682535082_1620893575377'
  let query = setQuery(url, 'load.Integration.sale.analyse', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-销售概览-地区销售金额占比
export const getSalesPieEchart = data => {
  const url = 'template/queryByTemplate_1625217738141'
  let query = setQuery(url, 'load.Integration.country.turnover', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-销售概览-顾客消费概况
export const getConsumeTable = data => {
  const url = 'template/queryByTemplate_1625218510223'
  let query = setQuery(url, 'load.Integration.customer.sale.overview', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 营销分析-销售概览-复购率月度趋势
export const getBuyBarEchart = data => {
  const url = 'template/queryByTemplate_1625219638029'
  let query = setQuery(url, 'load.Integration.repurchase.rate.trend', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 首页-销售榜
export const getSalesRankTable = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_16254526539469'
  let query = setQuery(url, 'load.Integration.home.sale.list', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 首页-退款榜
export const getRefundRankTable = data => {
  const url = 'template/queryByTemplate_66666_1619663692184_1619664202338_1619664931617_1619665695353_1625452653946_1625452963142'
  let query = setQuery(url, 'load.Integration.home.refund.list', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 库存管理-库存概览 卡片数据
export const getStockData = (data) => {
  const url = 'template/queryByTemplate__1621391275675_1621561635793_1625814822154_1625816463960'
  let query = setQuery(url, 'load.Integration.stock.over', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 库存管理-库存概览 列表数据
export const getStockTableData = (data) => {
  const url = 'template/queryByTemplate__1621391275675_1621561635793_1625814822154'
  let query = setQuery(url, 'load.Integration.stock.detail', data)
  query.data.pageInfo = {
    pageNum: data.pageNum,
    pageSize: data.pageSize
  }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 库存管理-库存概览  列表线图
export const getStickLineData = (data) => {
  const url = 'template/queryByTemplate__1621391275675_1621561635793_1625814822154_1625816463960_1626140500741'
  let query = setQuery(url, 'load.Integration.stock.sale.trend', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 获取类目
export const getProdCategories = data => {
  const url = 'template/queryByTemplate__1621391275675_1621561635793_1625814822154_1625816463960_1626319413267'
  let query = setQuery(url, 'load.Integration.stock.category.search', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 获取erp店铺
export const getErpMerchant = data => {
  const url = 'template/queryByTemplate_66666_1628649183420_1628652183325_1629438075333_1629438916146_1629439158490_1629443900569_1629444255729_1629444447983_1630380054150'
  let query = setQuery(url, 'load.erp.shoplist.data', data)
  // let query = {
  //   url,
  //   data: {
  //     template_id: 'load.Integration.ad.saleamount.top5',
  //     ...data
  //   }
  // }
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 经营日报-成交额
export const getDayCount = data => {
  const url =
    'template/queryByTemplate_1631511144539'
  let query = setQuery(url, 'load.shoplus.bi.daily.turnover', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 经营日报-成交额
export const getDayAdCount = data => {
  const url =
    'template/queryByTemplate_1631511508942'
  let query = setQuery(url, 'load.shoplus.bi.daily.ad', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 经营月报 card

export const getMonthCount = data => {
  const url =
    'template/queryByTemplate_1631511649702'
  let query = setQuery(url, 'load.shoplus.bi.month.turnover', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}

// 用户行为分析-访问设备占比
export const getIntegrationDevice = data => {
  const url = 'template/queryByTemplate_66666_1622188559030_1636437930018'
  let query = setQuery(url, 'load.Integration.op.device', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 独立访客-访问国家/地区分布图
export const getClientCountry = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614595436010_1614596341046_1614832289425'
  let query = setQuery(url, 'load.Integration.op.area.trans', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
// 访客UTM转化率
export const getUtmCountry = data => {
  const url = 'template/queryByTemplate_1614591364892_1614591697462_1614595436010_1614596341046_1614832289425'
  let query = setQuery(url, 'load.Integration.op.utm.trans', data)
  return request({
    method: 'post',
    url: query.url,
    data: query.data
  })
}
